import {FormControl, FormGroup} from "@angular/forms";
import {CustomerDetailsDTO} from "./customer-details-dto.model";
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

export class CustomerDTO extends CustomerDetailsDTO {

  legalEntityDTO: LegalEntityModel | undefined = undefined;

  static createForm(): FormGroup {
    return  new FormGroup({
      uuid: new FormControl(null),
      customerTerritoryVO: new FormControl(null),
      globalAccountDTO: new FormControl(null),
      legalEntityDTO: new FormControl(null),
      favourite: new FormControl(null)
    });
  }
}
